export function removeFromArray(array, predicate) {
    if (!Array.isArray(array)) {
        return;
    }
    const index = array.findIndex(predicate);
    if (index > -1) {
        array.splice(index, 1);
    }
}